import { fetchLookup, addLookup, editLookup, deleteLookupByID, destroyLookup } from "../actions/lookup_main_action";
import { fetchLookupMeta } from "../actions/lookup_main_meta_action";
import Helping from "../helpers/Helping";
import { API_URL } from '../config/urls';
import { LOOKUPS } from '../config/routes';
import Service from "../helpers/service";
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}

export const setMainLookupError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type) => {
  return dispatch => {
    return trackPromise(
      Service
        .postCall(API_URL.ADMIN_TRADING_API + LOOKUPS,
          {
            action: "list",
            page,
            limit,
            search: search.trim(),
            sorting,
            sort_type
          }
        )
        .then(response => {
          let total = response.data.payload.total;

          dispatch(fetchLookup(response.data.payload.lookups));
          dispatch(
            fetchLookupMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: total,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log("something went wrong while fetching Lookup list: ", error);
          dispatch(fetchLookup([]));
          dispatch(
            fetchLookupMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: 0,
              no_Of_pages: page
            })
          );
          Helping.redirectToLogin(error);
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching lookup")
          })
        })
    )
  };
};

export const create = lookup => {
  return dispatch => dispatch(addLookup(lookup));
};

export const update = lookup => {
  return dispatch => dispatch(editLookup(lookup));
};

export const deleteLookup = id => {
  return dispatch => {
    dispatch(deleteLookupByID(id));
  };
};

export const destroy = key => {
  return dispatch => dispatch(destroyLookup(key));
}
